import styled from 'styled-components';

import { Button } from '@xingternal/button';
import {
  spaceS,
  xdlColorHover,
  xdlColorHoverSecondary,
} from '@xingternal/tokens';

export const MoreMenuButton = styled(Button)`
  border: 0;
  flex: 1 0 1px;
  padding: ${spaceS} 0;
  height: 100%;

  &:hover {
    background-color: ${xdlColorHover};
  }
  &:active {
    background-color: ${xdlColorHoverSecondary};
  }

  & > div {
    align-items: center;
    display: flex;
    justify-content: center;

    & > span {
      flex-direction: column;
      align-items: center;

      & > p {
        font-size: 12px;
        font-weight: 400;
        margin: 2px 0 0;
      }
    }
  }
`;
